/* eslint-disable no-useless-escape*/
import printCss from './print.txt';

let ticketStyle = printCss.trimStart();
/**
 * Change the font family from APP_SETTINGS if present
 */
if (APP_SETTINGS && APP_SETTINGS.print && APP_SETTINGS.print.fontFamily && APP_SETTINGS.print.fontFamily !== 'monospace') {
  ticketStyle = ticketStyle.replace(/\s*(font-family:)\s*(\w+);\s*/g, ` $1 ${APP_SETTINGS.print.fontFamily}; `);
}

let computedStyles = '@media print {\n';
/**
 * Change font-size from APP_SETTINGS if present
 */
if (APP_SETTINGS && APP_SETTINGS.print && APP_SETTINGS.print.fontSize) {
  const modifiyFontSize = ticketStyle.match(/.*\s*\/\*[\+xX](\d+)\*\/\s*(font-size:) \w+; /g);
  const fontSize = +APP_SETTINGS.print.fontSize;
  modifiyFontSize.forEach(mt => {
    const num = +mt.replace(/.*\s*\/\*[\+xX](\d+)\*\/\s*(font-size:) \w+; /g, '$1');
    const operand = mt.replace(/.*\s*\/\*([\+xX])\d+\*\/\s*(font-size:) \w+; /g, '$1').toLowerCase();
    const cssClass = mt.replace(/(.*\s*{).*/, '$1');
    let newStyle = '';
    switch (operand) {
      case '+':
        newStyle = `font-size: ${fontSize + num}pt;`;
        break;
      case 'x':
        newStyle = `font-size: ${fontSize * num}pt;`;
        break;
      default:
        break;
    }
    computedStyles += `${cssClass} ${newStyle} }\n`;
  });
}
computedStyles += '}';

export { ticketStyle, computedStyles };
